import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../components/bannerfrom";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Seattle">
                <h1>
                  Collaborate with the Best Mobile App Developers in Seattle
                </h1>
              </div>
              <p className="main_para">
                TekRevol is a globally recognized company in the tech industry,
                especially in the mobile app development sector. Our service
                quality is based on diverse app solutions developed by our
                mobile app developers Seattle. Considering the potential of tech
                growth, we have broadened our horizon in this region by
                introducing some innovative mobile apps that may create a
                positive difference in the market. We are focused on the
                continual development of businesses with innovative mobile app
                services to ensure a solid online presence.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={5} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
